import CardWithImage from "./CardWithImage";
import Tabs from "./Tabs";

const PoplarAttractions = () => {
  return (
    <div
      className="w-[90%] lg:w-[80%] xl:w-2/3 my-12 xl:my-6 hidden md:flex rounded-lg  flex-col mx-auto "
      //   style={containerStyle}
    >
      <h3 className="text-3xl text-[#000046] font-bold">
        Popular Destinations<span className="text-[#EE723A]">.</span>
      </h3>

      <Tabs />
      <div className="my-6 flex overflow-x-scroll">
        <CardWithImage
          img={
            "https://images.unsplash.com/photo-1555109307-f7d9da25c244?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxleHBsb3JlLWZlZWR8Mnx8fGVufDB8fHx8fA%3D%3D"
          }
          name="New York"
        />
        <CardWithImage
          img={
            "https://images.unsplash.com/photo-1581351721010-8cf859cb14a4?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxleHBsb3JlLWZlZWR8Mnx8fGVufDB8fHx8fA%3D%3D"
          }
          name="Las Vegas"
        />
        <CardWithImage
          img={
            "https://images.unsplash.com/photo-1560889021-ef803239616d?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxleHBsb3JlLWZlZWR8NDV8fHxlbnwwfHx8fHw%3D"
          }
          name="San Fransicso"
        />
        <CardWithImage
          img={
            "https://www.hawaiipictures.com/cdn/shop/t/4/assets/slide_1.jpg?v=68763682233513713121533937281"
          }
          name="Hawaii"
        />{" "}
        <CardWithImage
          img={
            "https://a.travel-assets.com/findyours-php/viewfinder/images/res70/339000/339656-Downtown-Miami.jpg"
          }
          name="Miami"
        />
      </div>
    </div>
  );
};

export default PoplarAttractions;
